/**
 * Emoji representativo do alimento — placeholder reconhecível quando ainda não há
 * foto real (a foto de verdade vem da câmera do cuidador). Usado sobretudo no modo
 * criança, onde a imagem é o que comunica. Mapa por nome; cai pra categoria; depois
 * pro prato genérico.
 */
const semAcento = (s: string) =>
  s
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .trim();

const POR_NOME: Record<string, string> = {
  morango: "🍓",
  banana: "🍌",
  brocolis: "🥦",
  ervilha: "🫛",
  cenoura: "🥕",
  maca: "🍎",
  tomate: "🍅",
  uva: "🍇",
  laranja: "🍊",
  melancia: "🍉",
  pao: "🍞",
  arroz: "🍚",
  feijao: "🫘",
  ovo: "🥚",
  leite: "🥛",
  iogurte: "🥛",
  queijo: "🧀",
  frango: "🍗",
  carne: "🥩",
  peixe: "🐟",
  batata: "🥔",
  milho: "🌽",
  abacate: "🥑",
  pera: "🍐",
  manga: "🥭",
  abacaxi: "🍍",
  melao: "🍈",
  morango_silvestre: "🍓",
  biscoito: "🍪",
  bolacha: "🍪",
  bolo: "🍰",
  cereal: "🥣",
  macarrao: "🍝",
  pepino: "🥒",
  alface: "🥬",
  cebola: "🧅",
  pimentao: "🫑",
  cogumelo: "🍄",
  amendoim: "🥜",
  coco: "🥥",
  limao: "🍋",
  cereja: "🍒",
  pessego: "🍑",
  // populares — proteínas
  "carne moida": "🥩",
  lentilha: "🫘",
  "grao-de-bico": "🫛",
  almondega: "🍖",
  salsicha: "🌭",
  "peito de peru": "🦃",
  peru: "🦃",
  atum: "🐟",
  hamburguer: "🍔",
  // populares — carboidratos
  "batata-doce": "🍠",
  mandioca: "🥔",
  polenta: "🌽",
  tapioca: "🫓",
  aveia: "🥣",
  cuscuz: "🍚",
  panqueca: "🥞",
  // populares — fibras
  abobrinha: "🥒",
  espinafre: "🥬",
  beterraba: "🥬",
  "couve-flor": "🥦",
  vagem: "🫛",
  abobora: "🎃",
  // populares — frutas
  mamao: "🍈",
  // populares — laticínios
  requeijao: "🧀",
  "petit suisse": "🥛",
  "queijo cottage": "🧀",
  "cream cheese": "🧀",
  coalhada: "🥛",
  manteiga: "🧈",
  mussarela: "🧀",
  "leite fermentado": "🥛",
  nata: "🥛",
  // populares — outros
  gelatina: "🍮",
  suco: "🧃",
  achocolatado: "🥛",
  pipoca: "🍿",
  geleia: "🍯",
  mel: "🍯",
  granola: "🥣",
  barrinha: "🍫",
  sorvete: "🍦",
};

const POR_CATEGORIA: Record<string, string> = {
  // grupos alimentares (usados como fallback dos populares)
  proteina: "🍖",
  carboidrato: "🍚",
  fibra: "🥦",
  fruta: "🍎",
  frutas: "🍎",
  legume: "🥦",
  legumes: "🥦",
  verdura: "🥬",
  verduras: "🥬",
  carne: "🍖",
  carnes: "🍖",
  laticinio: "🥛",
  laticinios: "🥛",
  cereal: "🌾",
  cereais: "🌾",
  graos: "🌾",
  doce: "🍪",
  doces: "🍪",
  bebida: "🥤",
  bebidas: "🥤",
};

export function emojiAlimento(nome?: string | null, categoria?: string | null): string {
  if (nome) {
    const n = semAcento(nome);
    if (POR_NOME[n]) return POR_NOME[n];
    // tenta a primeira palavra (ex.: "morango fresco")
    const primeira = n.split(/\s+/)[0];
    if (POR_NOME[primeira]) return POR_NOME[primeira];
  }
  if (categoria) {
    const c = semAcento(categoria);
    if (POR_CATEGORIA[c]) return POR_CATEGORIA[c];
  }
  return "🍽️";
}
